<template>
    <div>
        <div>
        <b-jumbotron border-variant="secondary" text-variant="dark">
            <template #header>Plataforma Creatum</template>

            <template #lead>
            Bienvenido a la plataforma, aqui podras mantenerte informado del estado de los inventarios, pedidos, precios y mucho mas.
            </template>

            <hr class="my-4">

            <p>
            Recuerda visitar nuestro sitio web.
            </p>

            <b-button variant="dark" target="_blank" href="https://creatum.com.co">Ir a Creatum.com.co</b-button>
            <!-- <b-button variant="success" href="#">Do Something Else</b-button> -->
        </b-jumbotron>
        </div>
    </div>
</template>
<script>
export default {
    components: {
    },
    data () {
        return {
        }
    },
    methods:{
    }
}
</script>